import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.orders')
  .factory('OrdersAPI', OrdersAPI);

function OrdersAPI(): BringozApi {
  return {
    base: `/services-orders`,
    infiniteScroll: {
      address: `/services-orders`,
      cmd: 'GET'
    },
    actions : {
      quoteOld : {
        address : 'quote',
        cmd : 'POST',
        updateable: false
      },
      quote: {
        address : 'quote/v2',
        cmd : 'POST',
        updateable: false
      },
      settings: {
        address : 'settings',
        cmd : 'GET',
        updateable: false
      },
      validate : {
        address : 'validate',
        cmd : 'POST',
        updateable: false
      },
      price : {
        address : 'price',
        cmd : 'POST',
        updateable: false
      },
      place : {
        address : 'place',
        cmd : 'PUT',
        updateable: false
      }
    }
  }
}
